import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const ProjectCard = ({ project }) => {
  // Use slug if available, fallback to id
  const projectUrl = project.slug || project.id;
  
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="w-full"
      data-testid={`project-card-${project.id}`}
    >
      <Link 
        to={`/projects/${projectUrl}`}
        className="project-card group relative block overflow-hidden border border-white/5 hover:border-primary/50 transition-all duration-500 rounded-lg"
      >
        <div className="relative w-full aspect-video bg-black">
          <img
            src={project.images[0] || 'https://images.unsplash.com/photo-1522139137660-4248e04955b8?w=800'}
            alt={project.title}
            className="w-full h-full object-contain transition-transform duration-500 group-hover:scale-105"
            loading="lazy"
          />
        </div>
        
        <div className="bg-card p-6 border-t border-white/5">
          <div className="text-xs uppercase tracking-[0.2em] font-mono text-primary mb-2" data-testid={`project-category-${project.id}`}>
            {project.category}
          </div>
          <h3 className="text-xl md:text-2xl font-bold font-['Syne'] tracking-tight mb-2" data-testid={`project-title-${project.id}`}>
            {project.title}
          </h3>
          <p className="text-sm text-muted-foreground line-clamp-2">
            {project.description}
          </p>
        </div>
      </Link>
    </motion.div>
  );
};

export default ProjectCard;
